import styled from "styled-components";
import {
  MarginProps,
  BorderRadiusProps,
  ColorProps,
  HeightProps,
  WidthProps,
  PaddingProps,
  margin,
  borderRadius,
  color,
  height,
  width,
  padding,
} from "styled-system";

export const FillSvg = styled.div<
  | MarginProps
  | BorderRadiusProps
  | ColorProps
  | HeightProps
  | WidthProps
  | PaddingProps
>(margin, borderRadius, color, height, width, padding, (props) => ({
  fill: props.color,
}));
